@for (step of steps; track step) {
  <div
    (click)="clickStep(step)"
    class="wizard-progress__step"
    [class.wizard-progress__step--completed]="step.completed"
    [class.wizard-progress__step--active]="step.active"
    [class.wizard-progress__step--disabled]="step.disabled"
    >
    <campus-icon class="wizard-progress__icon" [svgIcon]="step.svgIcon"></campus-icon>
    <span class="wizard-progress__label ui-body-1">{{ step.label }}</span>
  </div>
}
